import { AgreementBUInterface, BusinessUnitInterface } from '../interfaces'

/**
 * Oficinas ORIGEN del contrato (`/Agreement/AgreementBU`, isSource=true).
 *
 * Las TIENDAS DESTINO permitidas NO salen de acá: viven en
 * `utils/destinationBusinessUnits.ts`, que las lee de AccountSiteBU y espeja la
 * regla que ApiCore aplica de verdad (ShipmentController.cs:396-419). Son dos
 * fuentes distintas a propósito; no unificarlas sin confirmar con backend.
 */

export const AGREEMENT_BU_ACTIVE_STATUS = 1

// Filtra AgreementBU usables (isSource, !isLocked, statusID activo) y las mapea
// a la BusinessUnit completa por buCode, deduplicando por buid. Pura/testeable.
export const resolveOriginBusinessUnits = (
  agreementBUs: AgreementBUInterface[],
  businessUnits: BusinessUnitInterface[]
): BusinessUnitInterface[] => {
  const usable = agreementBUs.filter(
    (a) =>
      a.isSource &&
      !a.isLocked &&
      (a.statusID === AGREEMENT_BU_ACTIVE_STATUS || a.statusID == null)
  )

  const resolved: BusinessUnitInterface[] = []
  const seen = new Set<number>()

  usable.forEach((a) => {
    const bu = businessUnits.find((b) => b.buCode === a.buCode)
    if (!bu) {
      console.warn(`AgreementBU buCode sin match en catálogo: ${a.buCode}`)
      return
    }
    if (seen.has(bu.buid)) return
    seen.add(bu.buid)
    resolved.push(bu)
  })

  return resolved
}

// ---------------------------------------------------------------------------
// Tiendas origen escritas en el Excel que el contrato NO habilita
// ---------------------------------------------------------------------------

interface OriginBuLike {
  buCode?: string
}

interface GroupWithOrigin {
  originStoreCode?: string
}

/**
 * buCodes de tienda origen presentes en las guías que NO están entre las oficinas
 * origen del contrato, sin repetir y en el orden en que aparecen.
 *
 * Existe para el aviso general del Review. La columna "Oficina origen" del Excel se
 * escribe a mano, y `parseOriginBuCode` preserva el token tal cual venga aunque no
 * matchee el catálogo (para que se pueda avisar). Con UNA sola oficina en el contrato
 * no hay nada que elegir y la fila no se marca en rojo: el operador tiene que enterarse
 * por este aviso de que su columna se ignoró y bajo qué tienda salen las guías.
 *
 * Con VARIAS oficinas el aviso no aplica: ahí `validateGroup` marca cada fila en rojo
 * y el Review bloquea el envío hasta que se elija una válida.
 */
export const unauthorizedOriginStoreCodes = (
  groups: GroupWithOrigin[],
  originBusinessUnits: OriginBuLike[]
): string[] => {
  const allowed = new Set(
    originBusinessUnits.map((b) => b.buCode).filter(Boolean)
  )
  const found: string[] = []
  groups.forEach((g) => {
    const code = g.originStoreCode?.trim()
    if (!code || allowed.has(code) || found.includes(code)) return
    found.push(code)
  })
  return found
}
